import { BundleOut } from '../api';
import { AxiosError } from 'axios';

export const BUNDLE_REQUEST = 'BUNDLE_REQUEST';
export const BUNDLE_SUCCESS = 'BUNDLE_SUCCESS';
export const BUNDLE_FAILURE = 'BUNDLE_FAILURE';

export const ADD_BUNDLE_TO_CART = 'ADD_BUNDLE_TO_CART';
export const ADD_BUNDLE_TO_CART_FINISHED = 'ADD_BUNDLE_TO_CART_FINISHED';

export const ADD_BUNDLE_TO_LIST = 'ADD_BUNDLE_TO_LIST';
export const ADD_BUNDLE_TO_LIST_FINISHED = 'ADD_BUNDLE_TO_LIST_FINISHED';

interface BundleRequest {
    type: typeof BUNDLE_REQUEST;
    payload: string;
}

interface BundleSuccess {
    type: typeof BUNDLE_SUCCESS;
    payload: BundleOut;
}

interface BundleFailure {
    type: typeof BUNDLE_FAILURE;
    payload: AxiosError;
    error: boolean;
}

interface AddBundleToCart {
    type: typeof ADD_BUNDLE_TO_CART;
}

interface AddBundleToCartFinished {
    type: typeof ADD_BUNDLE_TO_CART_FINISHED;
}

interface AddBundleToList {
    type: typeof ADD_BUNDLE_TO_LIST;
}

interface AddBundleToListFinished {
    type: typeof ADD_BUNDLE_TO_LIST_FINISHED;
}

export type BundleAction =
    | BundleRequest
    | BundleSuccess
    | BundleFailure
    | AddBundleToCart
    | AddBundleToCartFinished
    | AddBundleToList
    | AddBundleToListFinished;
